<template>
  <!-- 设备报修相关 -->
  <van-action-sheet v-model="showSheet" :title="sysFormTitles.deviceRepair">
    <van-form label-align="right" label-width="75" @submit="onSubmit"
              validate-trigger="onSubmit" ref="repairSheet">
      <van-field name="radio" label="严重程度">
        <template #input>
          <van-radio-group v-model="severity" direction="horizontal">
            <van-radio v-for="name in Object.keys(severityMap)"
                       :key="name" :name="name">{{severityMap[name]}}
            </van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field v-model="specificContent" rows="1" autosize type="textarea"
                 label="详情描述" placeholder="请填写"
                 :rules="[{required: true, message: '请填写报修详情' }]"></van-field>
      <div class="mar-all">
        <van-button class="theme-btn" block size="small">提交</van-button>
      </div>
    </van-form>
  </van-action-sheet>
</template>

<script>
  import {repair} from "../../../../server";
  import {checkRespCorrect} from "../../../../tools/utils";
  import {messageHdl, msgCode} from "../../../../tools/messageHdlr";
  import {serviceConfig} from "../../../../config/common";

  export default {
    props: {
      meetingRoomId: String,
      show: Boolean
    },
    data() {
      return {
        severityMap: serviceConfig.severityMap,
        severity: "serious",
        specificContent: ""
      }
    },
    computed: {
      sysFormTitles() {
        return this.$store.state.formTitles
      },
      showSheet: {
        get() {
          return this.show
        },
        set(val) {
          this.$emit('handle-cancel', val)
        },
      }
    },
    watch: {
      showSheet(val) {
        this.resetSheet()
      },
    },
    methods: {
      onSubmit() {
        const data = {
          meetingRoomId: this.meetingRoomId,
          severity: this.severity,
          specificContent: this.specificContent
        };
        // 提交报修
        if (data.severity && data.specificContent) {
          repair.submitRepair(this, {req: data}).then(({submitRepair: resp = {}}) => {
            if (checkRespCorrect(resp, "提交失败")) {
              messageHdl({code: msgCode.SUCCESS, msg: "提交成功"});
              this.showSheet = false;
            }
          }).catch(err => {
            messageHdl({msg: err.message});
          })
        }
      },
      resetSheet() {
        this.severity = "serious";
        this.specificContent = "";
        this.$refs.repairSheet && this.$refs.repairSheet.resetValidation()
      }
    }
  }
</script>

<style scoped>
</style>
